import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from '../Text';
import Styles from './InputCheck.styles';
import { WHITE } from '../../../constants/colors';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const InputWrapper = styled.div`${Styles.inputWrapper}`; // prettier-ignore
const Label = styled(Text).attrs({ bold: true })`${Styles.label}`; // prettier-ignore
const Input = styled.input`${Styles.input}`; // prettier-ignore

/**
 * InputCheckBox component
 * @param {string} prop.label - input label
 * @returns {JSX}
 */
const InputCheckBox = ({
  label, name, onChange, value, reference, checked, color, className, backgroundColor
}) => {
  return (
    <Wrapper className={className}>
      <InputWrapper backgroundColor={backgroundColor}>
        <Input
          type="checkbox"
          value={value}
          innerRef={reference}
          checked={checked}
          onChange={onChange}
          name={name}
        />
        <Label color={color}>{label}</Label>
      </InputWrapper>
    </Wrapper>
  );
};

InputCheckBox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  reference: PropTypes.object,
  checked: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  backgroundColor: PropTypes.string
};

InputCheckBox.defaultProps = {
  checked: false,
  backgroundColor: WHITE
};

export default InputCheckBox;
